module.exports = __webpack_public_path__ + "static/media/ilustration-without-background.e5da9788.png";